t = require('views/internal/teacup-with-helpers')('reactions')

module.exports = t.renderable ({ disabled, icon }) ->
  iconUrl = "/images/reactions/#{icon}#{if disabled then '-disabled' else ''}"

  t.div '.reactions-add', ->
    t.img '.reactions-add-img',
      alt: t.l 'add-reaction'
      class: t.classify(disabled: disabled)
      src: "#{ iconUrl }.png"
      srcset: "#{ iconUrl }.png 1x, #{ iconUrl }@2x.png 2x"
      title: t.l 'add-reaction'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/reaction_icon.coffee